/* eslint-disable strict */

'use strict';

/**
 * Mobile and desktop variant update.
 */
(function ProductBuyBars() {
  var $productForm = $('[data-product-form]');
  var $barDesktop = $('[data-mdv-buy-desktop]');
  var $barMobile = $('[data-mdv-buy-mobile]');
  var $buyDesktop = $barDesktop.find('[data-atc-submit]');
  var $buyMobile = $barMobile.find('[data-atc-submit]');
  var $variantSelectBarDesktop = $barDesktop.find('select');
  var $variantSelectProductForm = $('[data-product-form] [data-variant-select]');

  var MDVDesktop = Simba.ModelDrivenView.init($barDesktop);
  var MDVMobile = Simba.ModelDrivenView.init($barMobile);

  document.addEventListener('variant:change', updateMDV, false);
  $buyDesktop.on('click', submitProductForm);
  $buyMobile.on('click', submitProductForm);
  $variantSelectBarDesktop.on('change', updateProductSelect);

  // Handle variant change
  function updateMDV(evt) {
    var variant = evt.detail.variant;

    if (typeof variant !== 'object') return;

    // Update All Main Variant Selectors On Page
    const mainProductSelects = document.querySelectorAll('[name="id"]');
    mainProductSelects.forEach((productSelect) => {
      productSelect.value = variant.id;
    });

    // Handle desktop bar update
    MDVDesktop.setPrice = variant.priceFormattedWithoutTrailingZeros;
    MDVDesktop.setProductTitle = variant.productGroup.handle ? variant.productGroup.name : variant.productTitle;
    MDVDesktop.setVariantSelect = variant.id;
    MDVDesktop.setAtcVariantId = variant.id;
    if (variant.external) MDVDesktop.setAtcExternalURL = variant.external;

    // Handle mobile bar update
    MDVMobile.setPrice = variant.priceFormattedWithoutTrailingZeros;
    if (variant.external) MDVMobile.setAtcExternalURL = variant.external;
  }

  // Update product form select with buy bar select option
  function updateProductSelect() {
    $variantSelectProductForm.val(this.value).trigger('change');
  }

  // Handle buy bar button click - The buy bar ATC can also be a link
  function submitProductForm() {
    /* eslint-disable-next-line */
    if (this.tagName === 'BUTTON') $productForm[0].dispatchEvent(new Event('submit'));
  }
})();

/**
 * Show/hide desktop buy bar.
 */
(function DesktopBuyBarVisibility() {
  var trigger = document.querySelector('[data-product-form]');
  var barDesktop = document.querySelector('[data-mdv-buy-desktop]');

  new IntersectionObserver(toggle).observe(trigger);

  /**
   * Toggle bar visibility based on intersectionRatio value.
   * Return if viewport is underMedia().
   * @param {Array} entries IntersectionObserverEntry objects.
   */
  function toggle(entries) {
    if (underMedia()) return;
    entries[0].intersectionRatio <= 0 ? show() : hide();
  }

  /**
   * Hide and animate bar
   */
  function hide() {
    if (barDesktop.hasAttribute('hidden')) return;

    barDesktop.setAttribute('hidden', true);
    animate(barDesktop, 'reverse');
  }

  /**
   * Show and animate bar
   */
  function show() {
    barDesktop.removeAttribute('hidden');
    animate(barDesktop, 'normal');
  }

  /**
   * Animate the desktop buy bar.
   * @param {HTMLElement} element Element to be animated.
   * @param {String} direction Animation direction.
   */
  function animate(element, direction) {
    element.setAttribute('data-bar-is-animating', true);

    element.animate(
      [{ transform: 'translateY(-110%)' }, { transform: 'translateY(0%)' }],

      {
        duration: 180,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }
    ).onfinish = function () {
      element.removeAttribute('data-bar-is-animating');
      this.cancel();
    };
  }

  /**
   * matchMedia util.
   * @return {Boolean} Current viewport is under assigned breakpoint.
   */
  function underMedia() {
    return !window.matchMedia('(min-width: 1024px)').matches;
  }
})();
